import { useEffect, useRef } from 'react'

const AUTH_BG_VIDEO_WEBM_SRC = '/auth-bg-video-v2.webm'
const AUTH_BG_VIDEO_MP4_SRC = '/auth-bg-video-v2.mp4'
const AUTH_BG_POSTER_SRC = '/auth-bg-poster.jpg'

export const AuthBackgroundVideo = (): JSX.Element => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const resume = (): void => {
      if (document.visibilityState !== 'visible') return
      if (!video.paused) return
      void video.play().catch(() => {
        // Autoplay can be blocked by the browser; ignore — user interaction
        // will resume playback if needed.
      })
    }

    document.addEventListener('visibilitychange', resume)
    video.addEventListener('pause', resume)

    return () => {
      document.removeEventListener('visibilitychange', resume)
      video.removeEventListener('pause', resume)
    }
  }, [])

  return (
    <video
      ref={videoRef}
      data-testid="auth-background-video"
      autoPlay
      loop
      muted
      playsInline
      aria-hidden
      poster={AUTH_BG_POSTER_SRC}
      preload="auto"
      className="absolute inset-0 size-full object-cover"
    >
      <source
        data-testid="auth-bg-webm"
        src={AUTH_BG_VIDEO_WEBM_SRC}
        type="video/webm"
      />
      <source
        data-testid="auth-bg-mp4"
        src={AUTH_BG_VIDEO_MP4_SRC}
        type="video/mp4"
      />
    </video>
  )
}
